import HiristAuthForm from '@jobseeker/feature-authentication/components/Forms/HiristLogin';
import type {LoginFormProps} from '@jobseeker/feature-authentication/components/Forms/Login/type';

const HiristAuthPopup = (props: LoginFormProps) => {
  return <HiristAuthForm {...props} />;
};

export default HiristAuthPopup;
